import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class AmenityService {
  static getamenity(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getamenity}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getamenity}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addamenity(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addamenity}`;
    return axiosInstance
        .post(api,item)
        
}
static editamenity(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editamenity}`;
    return axiosInstance
        .put(api,item)
        
}
static deleteamenity(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteamenity}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deleteamenity}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default AmenityService;